import { WrapperWidget } from '@agentselly/ui';
import { EmptyState } from '~/components/empty/EmptyState';
import { T } from '@tolgee/react';
import { Button } from '~/components/ui/Button';

interface Props {
  readonly showDemoWidgetContent: boolean;
  readonly isBuyer: boolean;
}

export function SearchProfileWidget(props: Props) {
  if (!props.showDemoWidgetContent || !props.isBuyer) {
    return (
      <WrapperWidget>
        <EmptyState
          title={<T>widget_search_profile_title</T>}
          description={<T>widget_search_profile_description</T>}
        />
      </WrapperWidget>
    );
  }

  return (
    <WrapperWidget>
      <div className="h-full flex flex-col gap-y-6">
        <h2 className="text-lg font-bold">
          <T>widget_search_profile_title</T>
        </h2>
        <p>
          <T>widget_search_profile_description</T>
        </p>

        <div className="self-start">
          <a
            href={'https://www.agentselly.ch/suchprofil/'}
            target="_blank"
            rel="noopener noreferrer"
          >
            <Button
              primary
              showArrow
            >
              <T>widget_search_profile_button</T>
            </Button>
          </a>
        </div>
      </div>
    </WrapperWidget>
  );
}
